var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockNavy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 68.684,
    viewBox: "0 0 45 68.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "np_lock_4222614_000000",
    d: "M26.234,33.109V21.267A16.578,16.578,0,0,1,42.813,4.688v0A16.578,16.578,0,0,1,59.391,21.267V33.109h4.737a1.184,1.184,0,0,1,1.184,1.184V72.188a1.184,1.184,0,0,1-1.184,1.184H21.5a1.184,1.184,0,0,1-1.184-1.184V34.293A1.184,1.184,0,0,1,21.5,33.109ZM40.444,55.8a7.105,7.105,0,1,1,4.737,0v7.511a2.368,2.368,0,0,1-4.737,0ZM51.1,33.109V22.452a8.29,8.29,0,0,0-16.58,0V33.109Z",
    transform: "translate(-20.313 -4.688)",
    fill: "#121e59",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockNavy);
export default __webpack_public_path__ + "static/media/lockNavy.56ef4ca2111e73cc366e9149d2099324.svg";
export { ForwardRef as ReactComponent };